module.exports = __webpack_public_path__ + "static/media/locked.02164f54.svg";